import dynamic from 'next/dynamic'
import { useMemo } from 'react'

import { RenderOnFirstInteraction } from '@/components/RenderOnFirstInteraction'

import type { TMobileMenuProps } from './MobileMenu'

export const LazyMobileMenu = ({
	isOpen,
	setIsOpen,
	setHasLoaded,
	...props
}: TMobileMenuProps & {
	setHasLoaded: (hasLoaded: boolean) => void
}) => {
	const DynamicMobileMenu = useMemo(
		() =>
			dynamic(() =>
				import('./MobileMenu').then((mod) => {
					setHasLoaded(true)
					return mod.MobileMenu
				}),
			),
		[setHasLoaded],
	)

	return (
		<RenderOnFirstInteraction
			element={
				<DynamicMobileMenu {...props} isOpen={isOpen} setIsOpen={setIsOpen} />
			}
		/>
	)
}
